/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Cost_Title4Inputs */

const en_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost-aware architecture`)
};

const ar_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية تراعي التكلفة`)
};

const bn_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কস্ট-সচেতন আর্কিটেকচার`)
};

const de_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenbewusste Architektur`)
};

const es_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura consciente de los costos`)
};

const fr_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture soucieuse des coûts`)
};

const pt_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura consciente de custos`)
};

const zh_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本感知架构`)
};

const tr_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maliyet bilincine sahip mimari`)
};

const ru_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экономичная архитектура`)
};

const pl_svc_ai_integration_cost_title4 = /** @type {(inputs: Svc_Ai_Integration_Cost_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura uwzględniająca koszty`)
};

/**
* | output |
* | --- |
* | "Cost-aware architecture" |
*
* @param {Svc_Ai_Integration_Cost_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_cost_title4 = /** @type {((inputs?: Svc_Ai_Integration_Cost_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Cost_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_cost_title4(inputs)
	if (locale === "bn") return bn_svc_ai_integration_cost_title4(inputs)
	if (locale === "de") return de_svc_ai_integration_cost_title4(inputs)
	if (locale === "es") return es_svc_ai_integration_cost_title4(inputs)
	if (locale === "fr") return fr_svc_ai_integration_cost_title4(inputs)
	if (locale === "pt") return pt_svc_ai_integration_cost_title4(inputs)
	if (locale === "zh") return zh_svc_ai_integration_cost_title4(inputs)
	if (locale === "tr") return tr_svc_ai_integration_cost_title4(inputs)
	if (locale === "ru") return ru_svc_ai_integration_cost_title4(inputs)
	if (locale === "pl") return pl_svc_ai_integration_cost_title4(inputs)
	return en_svc_ai_integration_cost_title4(inputs)
});
export { svc_ai_integration_cost_title4 as "svc_ai-integration_COST_title" }